module.exports = __webpack_public_path__ + "static/media/tap_08_img.a107efd2.png";